import { breakpoints } from "@tvg/design-system";
import styled from "styled-components";

export const Container = styled.section`
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const RaceInfoContainer = styled.div`
  padding: 0 ${({ theme }) => theme.space["space-4"]};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;
